/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import FeelingEvasSectionContent from "parog-web/components/feeling-evas/sliders/component";
import type { EmberChangeset } from "ember-changeset";
import type { WrFormComponentSignature } from "ember-wiser/components/wr/form";

interface Signature {
  Args: {
    form: WrFormComponentSignature<
      EmberChangeset,
      unknown
    >["Blocks"]["default"][0];
  };
}

export default class extends FeelingEvasSectionContent<Signature> {}
